export const dateFilters = [
  {
    id: 'morning',
    title: 'Morning',
    from: 0,
    to: 11 * 3600 * 1000 + 59 * 60 * 1000,
    atHomeFrom: 9 * 3600 * 1000,
    atHomeTo: 13 * 3600 * 1000,
  },
  {
    id: 'afternoon',
    title: 'Afternoon',
    from: 12 * 3600 * 1000,
    to: 16 * 3600 * 1000 + 59 * 60 * 1000,
    atHomeFrom: 13 * 3600 * 1000,
    atHomeTo: 17 * 3600 * 1000,
  },
  {
    id: 'evening',
    title: 'Evening',
    from: 17 * 3600 * 1000,
    to: 23 * 3600 * 1000 + 59 * 60 * 1000,
    atHomeFrom: 17 * 3600 * 1000,
    atHomeTo: 24 * 3600 * 1000,
  },
];

export const eligibleSlotsFilter = (dateFilter, timeSlot) =>
  timeSlot.from >= dateFilter.from && timeSlot.from <= dateFilter.to;

export const getGroupsConfig = () =>
  dateFilters.reduce(
    (acc, curr) => {
      acc.periods[curr.title] = {
        id: curr.id,
        from: curr.from,
        to: curr.to,
      };
      return acc;
    },
    {
      periods: {},
    },
  );
